import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { rupiah, tgl, today, monthStart } from "../../lib/format";
import { PdfButton, PeriodeFilter, dl } from "./shared";

export default function PenjualanPanel() {
  const [jual, setJual] = useState(null);
  const [start, setStart] = useState(monthStart());
  const [end, setEnd] = useState(today());

  useEffect(() => {
    api.get("/reports/penjualan", { params: { start: monthStart(), end: today() } }).then((r) => setJual(r.data)).catch(() => {});
  }, []);

  const applyFilter = () => {
    api.get("/reports/penjualan", { params: { start: start || undefined, end: end || undefined } })
      .then((r) => setJual(r.data)).catch(() => {});
  };

  return (
    <>
      <div className="flex items-center justify-between mt-4 mb-2">
        <h2 className="text-base font-bold tracking-tight">Laporan Penjualan</h2>
        <div className="flex gap-2">
          <PdfButton testid="penjualan-pdf-button" onClick={() => dl(`/reports/penjualan/pdf?start=${start}&end=${end}`, "laporan-penjualan.pdf")} />
          <PdfButton testid="penjualan-excel-button" label="Unduh Excel" onClick={() => dl(`/reports/penjualan/excel?start=${start}&end=${end}`, "laporan-penjualan.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")} />
        </div>
      </div>
      <PeriodeFilter start={start} end={end} setStart={setStart} setEnd={setEnd} onApply={applyFilter} />
      {jual && (
        <>
          <div className="mt-4 grid grid-cols-3 gap-3 mb-3" data-testid="penjualan-summary">
            <div className="rounded-md border border-border bg-white p-3"><p className="text-[10px] uppercase font-bold text-muted-foreground tracking-wide">Transaksi</p><p className="text-lg font-bold">{jual.jumlah_transaksi}</p></div>
            <div className="rounded-md border border-border bg-white p-3"><p className="text-[10px] uppercase font-bold text-muted-foreground tracking-wide">Penjualan</p><p className="text-sm font-bold">{rupiah(jual.total_penjualan)}</p></div>
            <div className="rounded-md border border-border bg-white p-3"><p className="text-[10px] uppercase font-bold text-muted-foreground tracking-wide">Laba</p><p className={`text-sm font-bold ${jual.total_laba >= 0 ? "text-emerald-600" : "text-red-600"}`}>{rupiah(jual.total_laba)}</p></div>
          </div>
          <div className="rounded-md border border-border bg-white divide-y divide-border" data-testid="penjualan-report">
            {jual.sales.length === 0 && <p className="p-4 text-sm text-muted-foreground">Tidak ada penjualan pada periode ini.</p>}
            {jual.sales.map((s) => (
              <div key={s.id} className="flex items-center justify-between p-3.5" data-testid={`penjualan-report-${s.id}`}>
                <div>
                  <p className="text-sm font-semibold">{s.nama}</p>
                  <p className="text-xs text-muted-foreground">{tgl(s.tanggal)} · {s.kode} · {s.metode === "transfer" ? "Transfer Bank" : "Tunai"}{s.nama_sales ? ` · Sales: ${s.nama_sales}` : ""} · HJD {rupiah(s.harga_jual_rencana)}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-bold">{rupiah(s.harga_jual)}</p>
                  <p className={`text-xs ${s.harga_jual - s.harga_beli >= 0 ? "text-emerald-600" : "text-red-600"}`}>+{rupiah(s.harga_jual - s.harga_beli)}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
